import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import { NodeViewWrapper } from '@tiptap/react';
import { useState, useRef } from 'react';

const VideoNodeView = ({ node, editor, getPos }) => {
    const [isImageDragging, setIsImageDragging] = useState(false);
    const [loadingFiles, setLoadingFiles] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const pulicationFileInputRef = useRef(null);

    // Handle Dragging Events
    const handleFileDragOver = (event) => {
        event.preventDefault();
        setIsImageDragging(true);
    };

    const handleFileDragLeave = () => {
        setIsImageDragging(false);
    };

    // Handle File Upload
    const handleImageGalleryUpload = (event) => {
        const files = event.target.files;
        handleFilesUpload(files);
    };

    const handleGalleryImageDrop = (event) => {
        event.preventDefault();
        setIsImageDragging(false);
        const files = event.dataTransfer.files;

        if (files.length > 1) {
            setErrorMessages(['Please select only one video.']);
            return;
        }

        handleFilesUpload(files);
    };

    const handleFilesUpload = (files) => {
        setLoadingFiles(true);
        const allowedTypes = [ 'video/mp4','video/quicktime','video/x-msvideo', 'video/x-ms-wmv', 'video/avchd','video/webm','video/x-flv'];
        const maxSize = 250 * 1024 * 1024 * 1024;

        let errors = [];

        if (files.length > 1) {
            errors.push('Please select only one image.');
        }

        for (let file of files) {
            if (!allowedTypes.includes(file.type)) {
                errors.push(`${file.name} is not a valid file type.`);
            }
            if (file.size > maxSize) {
                errors.push(`${file.name} exceeds the size limit of 128MB.`);
            }
        }
        
        if (errors.length > 0) {
            setErrorMessages(errors);
            setLoadingFiles(false);
        } else {
            const file = files[0]; // Uploading only one file
            
            const videoObjectURL = URL.createObjectURL(file);
            editor.chain().focus().setVideoBlock({ videoUrl: videoObjectURL, caption: '', thumbnailurl: '',loop:false }).run();
        }
    };



    return (
        <NodeViewWrapper>
            <div data-type="image" className={`image-node-wrapper`} data-drag-handle>
                <div>
                    <div className={`newpageLeftRow textBlock uploadImageBlock ${loadingFiles ? 'uploadRunning' : ''}`}>
                        <div
                            className={isImageDragging ? 'dragging fileUploadBox' : 'fileUploadBox'}
                            onDragOver={handleFileDragOver}
                            onDragLeave={handleFileDragLeave}
                            onDrop={handleGalleryImageDrop}
                        >
                            <input
                                type="file"
                                ref={pulicationFileInputRef}
                                id="pulication-file"
                                onChange={handleImageGalleryUpload}
                                accept=".mp4, .mov, .avi, .wmv, .avchd, .webm, .flv"
                                hidden
                            />
                            {
                                loadingFiles ?
                                    <div className="progress-wrap">
                                        <div className="progress">
                                            <div className="color"></div>
                                        </div>
                                    </div>
                                    :
                                    <div className="uploadFileBlock" onClick={() => document.getElementById("pulication-file").click()}>
                                        <div className="videoMiddleContent">
                                            <svg width="47" height="46" viewBox="0 0 47 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="3.5" y="3" width="40" height="40" rx="20" fill="#F2F4F7"/>
                                                <rect x="3.5" y="3" width="40" height="40" rx="20" stroke="#F9FAFB" strokeWidth="6"/>
                                                <path d="M31.4168 20.0733C31.4168 19.5937 31.4168 19.3539 31.322 19.2428C31.2397 19.1465 31.1163 19.0953 30.9899 19.1053C30.8444 19.1167 30.6748 19.2863 30.3357 19.6254L27.4585 22.5026L30.3357 25.3798C30.6748 25.7189 30.8444 25.8885 30.9899 25.8999C31.1163 25.9099 31.2397 25.8587 31.322 25.7624C31.4168 25.6513 31.4168 25.4115 31.4168 24.9319V20.0733Z" stroke="#475467" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M15.5835 20.7609C15.5835 19.4308 15.5835 18.7658 15.8424 18.2577C16.0701 17.8108 16.4334 17.4475 16.8803 17.2198C17.3883 16.9609 18.0534 16.9609 19.3835 16.9609H23.6585C24.9886 16.9609 25.6537 16.9609 26.1617 17.2198C26.6086 17.4475 26.9719 17.8108 27.1996 18.2577C27.4585 18.7658 27.4585 19.4308 27.4585 20.7609V24.2443C27.4585 25.5744 27.4585 26.2395 27.1996 26.7475C26.9719 27.1944 26.6086 27.5577 26.1617 27.7854C25.6537 28.0443 24.9886 28.0443 23.6585 28.0443H19.3835C18.0534 28.0443 17.3883 28.0443 16.8803 27.7854C16.4334 27.5577 16.0701 27.1944 15.8424 26.7475C15.5835 26.2395 15.5835 25.5744 15.5835 24.2443V20.7609Z" stroke="#475467" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            <p className="newPageImageUploadText">
                                                <span>Click to upload</span> or drag and drop <br />
                                                MP4, MOV, AVI, WMV, AVCHD, WebM, FLV
                                                (max. 250GB)
                                            </p>
                                            {errorMessages && errorMessages.length > 0 && (
                                                <div className="errorMessages">
                                                    {errorMessages.map((errorMessage, index) => (
                                                        <p key={index} className="error-message">
                                                            {errorMessage}
                                                        </p>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>

                </div>
            </div>
        </NodeViewWrapper>
    );
};

export const VideoEmbeds = Node.create({
    name: 'video',

    isolating: true,
    defining: true,
    group: 'block',
    draggable: true,
    selectable: true,
    inline: false,

    addAttributes() {
        return {
            videoUrl: {
                default: '',
            },
            thumbnailurl: {
                default:''
            },
            fullDisplay: {
                default: false,
            },
            loop:{
                default: false
            }
        };
    },

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', { 'data-type': this.name, ...HTMLAttributes }];
    },

    addCommands() {
        return {
            setVideoUpload: (videoUrl) => ({ commands }) => {
                return commands.insertContent(`<div data-type="${this.name}" data-image-url="${videoUrl}"></div>`);
            },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(VideoNodeView);
    },
});

